import { Box, Button, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "../../hooks/useIsMobile";

export default function ProjectPaper({ proj }) {

    // Initializes the navigator object.
    const navigate = useNavigate();

    // Initialize mobile sensor
    const isMobile = useIsMobile();

    // Returns a message if no project information is present.
    if (!proj) {
        return (
            <Typography variant="body1" color="error" align="center" margin="32px">
                No project data available.
            </Typography>
        );
    }

    return (
        <Box>
            <Button
                sx={{
                    padding: 0, 
                    textTransform: "none",
                }}
                onClick={() => navigate(`/projects/${proj.id}`)}
            >
                <Paper
                    key={proj.id}
                    elevation={6}
                    sx={{
                        variant: "outlined",
                        padding: "16px",
                        margin: "16px auto",
                        width: isMobile ? '80vw' : 600,
                    }}
                >
                    <Typography variant="h6" component="h2">
                        {proj.title}
                    </Typography>
                    <Typography variant="body1" sx={{ marginTop: "8px" }}>
                        {proj.description}
                    </Typography>
                    <Typography
                        variant="caption"
                        display="block"
                        sx={{ marginTop: "12px", fontStyle: "italic", color: "gray" }}
                    >
                        Last Updated: {new Date(proj.lastUpdated).toLocaleString()}
                    </Typography>
                </Paper>
            </Button>
        </Box>
    );
}

// Define PropTypes to ensure proper prop structure
ProjectPaper.propTypes = {
    proj: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        lastUpdated: PropTypes.string.isRequired, // Assuming ISO date format
    }),
    onClick: PropTypes.func,
};
